import RegisterPartnerInfoForm from './register-partner-info-form-container';

export default RegisterPartnerInfoForm;
